/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginAliases {
  BTN_REGISTER_NEW_USER = 'btn-register-new-user',
  LAYOUT_0 = 'layout-0',
  LOGIN_COMPONENT = 'login-component',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  SOCIAL_NETWORKS = 'social-networks',
  TEXT_INFO = 'text-info',
}
export { LoginAliases };
